import React from 'react';
import { inject, observer } from 'mobx-react';

@inject('portalLoginStore')
@observer
class LoginBtn extends React.Component {
    constructor(props) {
        super(props);
        this.onLogin = this.onLogin.bind(this);
    }


    render() {
        const { portalLoginStore, getState } = this.props;
        let { state, labelObj } = portalLoginStore;
        state = getState();
        const { loginSettingInfo } = state;
        let { loginForm } = loginSettingInfo;
        const { e8LoginButtonColor } = loginForm;

        return (
            <div className="loginBtn" style={{ color: e8LoginButtonColor }} onClick={this.onLogin}>
                {labelObj.login}
            </div>
        );
    }
    onLogin() {
        const { portalLoginStore, isSetting } = this.props;
        if (!isSetting) {
            portalLoginStore.onLogin();
        }
    }
}

export default LoginBtn;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/login/e8login/formCloud/LoginBtn.js